<!-- items-list.component.html -->
<div class="container">

  @if (!(hasAnyAnnotation$ | async) && (currentSite$ | async); as site) {
    <div class="empty-state-wrapper">
      <div class="empty-state">
        <mat-icon>analytics</mat-icon>

        <div class="empty-state-content">
          <div class="empty-state-title">
            {{ 'no_annotation_title' | transloco }}
          </div>

          <p>
            {{ 'create_annotation_description' | transloco }}
          </p>

          <div class="annotation-icons">
            <mat-icon>straighten</mat-icon>
            <mat-icon>activity_zone</mat-icon>
            <mat-icon>landscape</mat-icon>
            <mat-icon>altitude</mat-icon>
            <mat-icon>radio_button_checked</mat-icon>

            @if (site | module: [inspectionModule.ARCAD]) {
              <mat-icon>capture</mat-icon>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (hasAnyAnnotation$ | async) {
    <div class="search">
      <item-search></item-search>
    </div>
  }

  @if (hasAnyAnnotation$ | async) {
    <mat-tree
      [dataSource]="dataSource"
      [treeControl]="treeControl"
      [trackBy]="domTrackBy">
      <!-- CATEGORY NODE -->
      <mat-tree-node
        *matTreeNodeDef="let node; when: isCategory"
        style="display: flex; flex-direction: column">
        <div class="header">
          <button mat-icon-button matTreeNodeToggle>
            <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
          </button>
          <div class="section-title" style="padding-top: 4px">
            {{ node.name | uppercase }} ({{ getCateroryItemCount$(node.key) | async }})
          </div>
          <span class="spacer"></span>
          @if (treeControl.isExpanded(node)) {
            <button mat-icon-button
                    matTooltip="{{'sorts' | transloco}}"
                    [matMenuTriggerFor]="getSortMenu(node.key)">
              <mat-icon>sort</mat-icon>
            </button>
          }
          <mat-menu #measureSortMenu="matMenu">
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.MEASURES, SortField.NAME)">
              @if (measureSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.NAME) }}
                </mat-icon>
              }
              <span>{{'sort_by_name' | transloco}}</span>
            </button>
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.MEASURES, SortField.TYPE)">
              @if (measureSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.TYPE) }}
                </mat-icon>
              }
              <span>{{'sort_by_type' | transloco}}</span>
            </button>
          </mat-menu>
          <mat-menu #cutSortMenu="matMenu">
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.CUTS, SortField.NAME)">
              @if (cutSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.NAME) }}
                </mat-icon>
              }
              <span>{{'sort_by_name' | transloco}}</span>
            </button>
          </mat-menu>
          <mat-menu #elevationSortMenu="matMenu">
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.ELEVATIONS, SortField.NAME)">
              @if (elevationSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.NAME) }}
                </mat-icon>
              }
              <span>{{'sort_by_name' | transloco}}</span>
            </button>
          </mat-menu>
          <mat-menu #markerSortMenu="matMenu">
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.MARKERS, SortField.NAME)">
              @if (markerSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.NAME) }}
                </mat-icon>
              }
              <span>{{'sort_by_name' | transloco}}</span>
            </button>
          </mat-menu>
          <mat-menu #volumeSortMenu="matMenu">
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.VOLUMES, SortField.NAME)">
              @if (volumeSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.NAME) }}
                </mat-icon>
              }
              <span>{{'sort_by_name' | transloco}}</span>
            </button>
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.VOLUMES, SortField.VOLUME)">
              @if (volumeSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.VOLUME) }}
                </mat-icon>
              }
              <span>{{'sort_by_volume' | transloco}}</span>
            </button>
          </mat-menu>
          <mat-menu #detectionSortMenu="matMenu">
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.DETECTIONS, SortField.NAME)">
              @if (detectionSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.NAME) }}
                </mat-icon>
              }
              <span>{{'sort_by_name' | transloco}}</span>
            </button>
            <button mat-menu-item (click)="onClickSort($event, SortableListKey.DETECTIONS, SortField.CONFIDENCE)">
              @if (detectionSortConfig$ | async; as sortConfig) {
                <mat-icon>
                  {{ getSortIcon(sortConfig, SortField.CONFIDENCE) }}
                </mat-icon>
              }
              <span>{{'sort_by_confidence' | transloco}}</span>
            </button>
            <!--          <button mat-menu-item (click)="onClickSort($event, SortableListKey.DETECTIONS, SortField.EVOLUTION)">-->
            <!--            <mat-icon *ngIf="detectionSortConfig$ | async as sortConfig">-->
            <!--              {{ getSortIcon(sortConfig, SortField.EVOLUTION) }}-->
            <!--            </mat-icon>-->
            <!--            <span>{{'sort_by_evolution' | transloco}}</span>-->
            <!--          </button>-->
            @if ((currentSite$ | async)?.haveDetectionEmergencyTemplate) {
              <button
                mat-menu-item (click)="onClickSort($event, SortableListKey.DETECTIONS, SortField.EMERGENCY)">
                @if (detectionSortConfig$ | async; as sortConfig) {
                  <mat-icon>
                    {{ getSortIcon(sortConfig, SortField.EMERGENCY) }}
                  </mat-icon>
                }
                <span>{{'sort_by_emergency' | transloco}}</span>
              </button>
            }
          </mat-menu>
        </div>
        @if (treeControl.isExpanded(node)) {
          <item-list-header
            style="width: 100%; padding-left: 12px"
            [shareAvailable]="node.key !=='volume' && node.key!=='detection'"
            [shareOffAvailable]="node.key !=='volume' && node.key!=='detection'"
            [hasSelectedItems]="getCategoryState(node.key).hasSelected"
            [allItemsSelected]="getCategoryState(node.key).allSelected"
            [indeterminate]="getCategoryState(node.key).indeterminate"
            [disableShow]="!(getConfigDisplayForNode$(node.key) | async)"
            [disableHide]="!(getConfigDisplayForNode$(node.key) | async)"
            (allCheckboxStateChanged)="toggleAllInCategory(node.key, $event)"
            (clickShow)="onShowCategory(node.key)"
            (clickHide)="onHideCategory(node.key)"
            (clickShare)="onShareCategory(node.key)"
            (clickShareOff)="onShareOffCategory(node.key)"
            [moreMenu]="getMoreMenu(node.key)">
          </item-list-header>
        }
        <mat-menu #measureMoreMenu="matMenu">
          <button mat-menu-item class="warn-menu-item" (click)="onDeleteCategory('measure')">
            <mat-icon>delete</mat-icon>
            <span>{{'delete' | transloco}}</span>
          </button>
        </mat-menu>
        <mat-menu #cutMoreMenu="matMenu">
          <button mat-menu-item
                  (click)="onClickRetrieveCutsCoordinatesCSV()">
            <mat-icon>file_save</mat-icon>
            <span>{{'coordinates_csv' | transloco}}</span>
          </button>
          <button mat-menu-item
                  (click)="onClickGenerateCutsDXF()">
            <mat-icon>file_save</mat-icon>
            <span>{{'generate_cuts_book_dxf' | transloco}}</span>
          </button>
          <button mat-menu-item
                  (click)="onClickGenerateCutsReport()">
            <mat-icon>file_save</mat-icon>
            <span>{{'generate_cuts_report' | transloco}}</span>
          </button>
          <button mat-menu-item class="warn-menu-item" (click)="onDeleteCategory('cut')">
            <mat-icon>delete</mat-icon>
            <span>{{'delete' | transloco}}</span>
          </button>
        </mat-menu>
        <mat-menu #elevationMoreMenu="matMenu">
          <button mat-menu-item
                  (click)="onClickRetrieveElevationsCoordinantesCSV()">
            <mat-icon>file_save</mat-icon>
            <span>{{'coordinates_csv' | transloco}}</span>
          </button>
          <button mat-menu-item class="warn-menu-item" (click)="onDeleteCategory('elevation')">
            <mat-icon>delete</mat-icon>
            <span>{{'delete' | transloco}}</span>
          </button>
        </mat-menu>
        <mat-menu #markerMoreMenu="matMenu">
          <button mat-menu-item
                  (click)="onClickRetrieveMarkersCoordinantesCSV()">
            <mat-icon>file_save</mat-icon>
            <span>{{'coordinates_csv' | transloco}}</span>
          </button>
          <button mat-menu-item class="warn-menu-item" (click)="onDeleteCategory('marker')">
            <mat-icon>delete</mat-icon>
            <span>{{'delete' | transloco}}</span>
          </button>
        </mat-menu>
        <mat-menu #volumeMoreMenu="matMenu">
          <button mat-menu-item
                  (click)="onClickGenerateVolumesDXF()">
            <mat-icon>file_save</mat-icon>
            <span>{{'generate_contours_volumes_dxf' | transloco}}</span>
          </button>
        </mat-menu>
        <mat-menu #detectionMoreMenu="matMenu">
          <button mat-menu-item
                  (click)="onClickGenerateDetectionsReport()">
            <mat-icon>file_save</mat-icon>
            <span>{{'detection_report' | transloco}}</span>
          </button>
        </mat-menu>
      </mat-tree-node>
      <!-- ITEM NODE -->
      <mat-tree-node
        *matTreeNodeDef="let node; when: isItem"
        style="width: 100%; padding-left: 6px"
        (click)="onNodeClick(node)"
        [ngClass]="{'selected':
        node.id === (measureIdSelected$ | async)
        || node.id === (cutIdSelected$ | async)
        || node.id === (elevationIdSelected$ | async)
        || node.id === (markerIdSelected$ | async)
        || node.id === (detectionIdSelected$ | async)
        || node.id === (volumeIdSelected$ | async) }">
        <div class="item">
          <mat-checkbox
            disableRipple
            (click)="$event.stopPropagation()"
            (change)="toggleItem(node.type, node.id, $event.checked)"
            [checked]="isItemChecked(node.type, node.id)">
          </mat-checkbox>
          @switch (node.type) {
            @case ('measure') {
              <measure-card class="card" [measureId]="node.id"></measure-card>
            }
            @case ('cut') {
              <cut-card class="card" [cutId]="node.id"></cut-card>
            }
            @case ('elevation') {
              <elevation-card class="card" [elevationId]="node.id"></elevation-card>
            }
            @case ('marker') {
              <marker-card class="card" [markerId]="node.id"></marker-card>
            }
            @case ('detection') {
              <detection-card class="card" [detectionId]="node.id"></detection-card>
            }
            @case ('volume') {
              <volume-card class="card" [volumeId]="node.id"></volume-card>
            }
          }
        </div>
      </mat-tree-node>
    </mat-tree>
  }

</div>
